import { ClientSpearheadGameRule } from "./ClientSpearheadGameRule";

export class ClientDevSpearheadGameRule extends ClientSpearheadGameRule {
  dev = true;
  name = "Age of Sigmar v4 - Spearhead - DEV";
}
